import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "../../../store/store";
import { NetworkState, Network } from "../types/network";

import {
  getPrices,
  getEthereumBlock,
  getGasOracle,
} from "../api/networkApi";

const initialState: NetworkState = {
  networks: [],
  loading: false,
  error: null,
};

const networkSlice = createSlice({
  name: "network",
  initialState,

  reducers: {
    start(state) {
      state.loading = true;
      state.error = null;
    },

    fail(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    setNetworks(
      state,
      action: PayloadAction<Network[]>
    ) {
      state.loading = false;
      state.networks = action.payload;
    },
  },
});

export const {
  start,
  fail,
  setNetworks,
} = networkSlice.actions;

export default networkSlice.reducer;


export const fetchNetworks =
  () =>
  async (dispatch: AppDispatch) => {

    dispatch(start());

    try {

      // const [prices, block, gas] =
      //   await Promise.all([
      //     getPrices(),
      //     getEthereumBlock(),
      //     getGasOracle(),
      //   ]);
      const prices = await getPrices();
console.log("Prices", prices);

const block = await getEthereumBlock();
console.log("Block", block);

const gas = await getGasOracle();
console.log("Gas", gas);

      dispatch(
        setNetworks([
          {
            name: "Ethereum",
            symbol: "ETH",
            price: `$${prices.ethereum.usd}`,
            block: parseInt(
              block.result,
              16
            ).toLocaleString(),
            fee: `${gas.result.ProposeGasPrice} Gwei`,
            color: "blue",
          },
        ])
      );

    } catch (err: any) {

      dispatch(
        fail(err.message)
      );

    }

  };


  export type { NetworkState}